module.exports = __webpack_public_path__ + "static/img/8.d374ae0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/8.png
// module id = BwsD
// module chunks = 0